export default __webpack_public_path__ + "static/media/projectApprovers.198bc626.png";